/* eslint-disable react-hooks/exhaustive-deps */
import "./styles.css";
import { Box, Container, Grid } from "@mui/material";
import LoginBg from "../../../assets/img/login-bg.svg";
import SummitLogo from "../../logo/summitLogo.png";
type LoginUIProps = {
  title: string;
  reactElement: React.ReactNode;
};

const LoginUI = ({ title, reactElement }: LoginUIProps) => {
  return (
    <Container>
      <Box className="menuContainer">
        <Grid container>
          <Grid item md={1.85} className="logoContainer">
            <img src={SummitLogo} alt="summitLogo" />
          </Grid>
        </Grid>
      </Box>
      <Box sx={{ padding: "2.5% 12% 4% 12%" }}>
        <>
          <div className="shadowSection"></div>
          <img className="login-bg" src={LoginBg} alt="login-bg" />
          <Grid container justifyContent="flex-end">
            <Grid item md={5} className="loginGridWrapper">
              <h2>{title}</h2>
              {reactElement}
            </Grid>
            <Grid item md={0.85}></Grid>
          </Grid>
        </>
      </Box>
    </Container>
  );
};

export default LoginUI;
